<template>
	<div class="content">
		<h3>班组设置</h3>
		<div class="item">
			<div class="btn">
				<el-button icon="el-icon-plus" type="primary" @click="AddWork">添加</el-button>
				<el-button icon="el-icon-search" type="primary"  @click="SelWork">查询</el-button>
				<el-button type="primary">导出</el-button>
			</div>
			<el-form ref="selectworkform" style="width:Auto" inline :model="selectworkform" label-width="90px">
				<el-form-item label="工厂名称">
					<el-select v-model="selectworkform.FactoryID" clearable placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryCode"
						:label="item.FactoryName"
						:value="item.FactoryCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="车间名称">
					<el-select v-model="selectworkform.WorkshopID" clearable placeholder="请选择">
						<el-option
						v-for="item in workshop"
						:key="item.Workshopcode"
						:label="item.Workshopname"
						:value="item.Workshopcode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生产线名称">
					<el-select v-model="selectworkform.LineID" clearable placeholder="请选择">
						<el-option
						v-for="item in line"
						:key="item.LineId"
						:label="item.LineName"
						:value="item.LineId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="班组编号">
					<el-input v-model="selectworkform.ShiftID"></el-input>
				</el-form-item>
				<el-form-item label="班组名称">
					<el-input v-model="selectworkform.ShiftName"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column prop="FactoryId" label="工厂名称"></el-table-column>
				<el-table-column prop="WorkshopId" label="车间名称"></el-table-column>
				<el-table-column prop="LineId" label="产线名称"></el-table-column>
				<el-table-column prop="ShiftName" label="班组名称"></el-table-column>
				<el-table-column prop="ShiftId" label="班组编号"></el-table-column>
				<el-table-column prop="ActiveFlag" label="状态">
					<template slot-scope="scope">
						{{scope.row.ActiveFlag ? '启用' : '禁用'}}
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="EditWork(scope)">修改</el-button>
						<el-button type="text" @click="delWork(scope)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :title="dialogtype==1 ? '添加班组':'编辑班组'" @close="close" :visible.sync="dialogVisible" width="740px">
      		<el-form ref="workform" inline style="width:auto" :model="workform" :rules="rules" label-width="100px">
				<el-form-item label="工厂名称" prop="FactoryID">
                    <el-select v-model="workform.FactoryID" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryCode"
						:label="item.FactoryName"
						:value="item.FactoryCode">
						</el-option>
					</el-select>
                </el-form-item>
				<el-form-item label="车间名称" prop="WorkshopID">
					<el-select v-model="workform.WorkshopID" placeholder="请选择">
						<el-option
						v-for="item in workshop"
						:key="item.Workshopcode"
						:label="item.Workshopname"
						:value="item.Workshopcode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生产线名称">
					<el-select v-model="workform.LineID" placeholder="请选择">
						<el-option
						v-for="item in line"
						:key="item.LineId"
						:label="item.LineName"
						:value="item.LineId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="班组名称" prop="ShiftName">
					<el-input v-model="workform.ShiftName"></el-input>
				</el-form-item>
				<el-form-item label="班组编号" prop="ShiftID">
					<el-input v-model="workform.ShiftID"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="note">
					<el-input type="textarea" v-model="workform.note"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="ActiveFlag">
					<el-radio v-model="workform.ActiveFlag" :label="1">启用</el-radio>
  					<el-radio v-model="workform.ActiveFlag" :label="0">禁用</el-radio>
				</el-form-item>
			</el-form>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="restForm" v-if="dialogtype==1" type="warning">重 置</el-button>
        		<el-button type="primary" @click="SetWork">确 定</el-button>
      		</span>
    	</el-dialog>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			selectworkform: {
				FactoryID: '',
				WorkshopID: '',
				LineID: '',
				ShiftID: '',
				ShiftName: ''
			},
			workform:{
				FactoryID: '',
				CID: '',
				WorkshopID: '',
				ActiveFlag: 1,
				LineID: '',
				ShiftID: '',
				ShiftName: '',
				note:'',
				DataId:'0'
			},
			rules: {
				ShiftID:[
          			{ required: true, validator: validateNumber, message: '请输入班组编号，数字类型', trigger: 'blur' }
				],
				ShiftName:[
					{ required: true,  message: '请输入班组名称', trigger: 'blur' },
				]
			},
			factory: [],
			workshop: [],
			line: [],

			tableData: [],
			dialogVisible:false,
			dialogtype:0,
			editVisible:true,
		}
	},
	mounted(){
		this.SelFactory();	
		this.SelWorkShop();
		this.SelProduct()
	},
	methods: {
		AddWork(){
			this.editVisible=false
			this.dialogVisible=true;
			this.dialogtype=1;
		},
		EditWork(work){
			this.editVisible=true
			this.dialogVisible=true;
			this.dialogtype=2;
			this.$nextTick(() => {
				this.workform.FactoryID=work.row.FactoryId;
				this.workform.WorkshopID=work.row.WorkshopId;
				this.workform.LineID=work.row.LineId;
				this.workform.ShiftID=work.row.ShiftId;
				this.workform.ShiftName=work.row.ShiftName;
				this.workform.ActiveFlag=work.row.ActiveFlag;
				this.workform.DataId=work.row.DataId;
			})
		},
		close(){
			this.$refs['workform'].resetFields()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['workform'].resetFields()
			})
		},
		SelWork(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询车间
			this.$axios({
        		method: 'post',
        		url:'/FW/ShiftInfo.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
					FactoryID:this.selectworkform.FactoryID,
					WorkshopID:this.selectworkform.WorkshopID,
					LineID:this.selectworkform.LineID,
					ShiftID:this.selectworkform.ShiftID,
					ShiftName:this.selectworkform.ShiftName
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.tableData=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},
		SelFactory(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询工厂
			this.$axios({
        		method: 'post',
        		url:'/FW/Factory.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.factory=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},
		SelWorkShop(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询车间
			this.$axios({
        		method: 'post',
        		url:'/FW/WorkShop.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.workshop=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},
		SelProduct(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询生产线
			this.$axios({
        		method: 'post',
        		url:'/FW/ProductLine.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.line=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},
		SetWork(){
			this.$refs['workform'].validate((isValidate)=>{
				if(isValidate){
					var user = JSON.parse(sessionStorage.getItem('user'));
					this.workform.CID=user.QyNum
					if(this.dialogtype==1){
						//添加工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/ShiftInfo.ashx',
        			params: {
          				action:"add",
          				shift:this.workform
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelWork()()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}else if(this.dialogtype==2){
						//修改工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/ShiftInfo.ashx',
        			params: {
          				action:"edit",
						shift:this.workform
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelWork()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}
				}else{
					isValidate
				}
			})
		},
		delWork(scope){
				this.$axios({
        				method: 'post',
        				url:'/FW/ShiftInfo.ashx',
        			params: {
          				action:"delete",
          				shift:scope.row
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelWork()()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:10px 90px;
}
</style>


// WEBPACK FOOTER //
// src/pages/settingWork.vue